module.exports = __webpack_public_path__ + "img/U267B.7416e11f.png";